import {
  ADMIN_BOOLEAN_FIELDS,
  ADMIN_FIELD_TO_BE_KEY,
  ADMIN_READ_ONLY_FIELDS,
} from '../constants'
import type {
  PlayerDetailsAdminField,
  PlayerDetailsAdminValues,
} from '../types'

const trim = (value: string): string => (value ?? '').trim()

/**
 * Diff the given admin fields of `current` against `initial` and return the
 * changed ones keyed by their API name. Same rules as the shared
 * `toUpdatePayload`: strings are trimmed before comparing and a cleared string
 * is sent as `''`; booleans are sent whenever they flip. Read-only fields are
 * never sent.
 */
export const toAdminPayload = (
  current: PlayerDetailsAdminValues,
  initial: PlayerDetailsAdminValues,
  fields: ReadonlyArray<PlayerDetailsAdminField>
): Record<string, string | boolean> =>
  fields.reduce<Record<string, string | boolean>>((payload, field) => {
    if (ADMIN_READ_ONLY_FIELDS.has(field)) {
      return payload
    }
    const beKey = ADMIN_FIELD_TO_BE_KEY[field]
    if (ADMIN_BOOLEAN_FIELDS.has(field)) {
      const next = Boolean(current[field])
      return next === Boolean(initial[field])
        ? payload
        : { ...payload, [beKey]: next }
    }
    const next = trim(current[field] as string)
    return next === trim(initial[field] as string)
      ? payload
      : { ...payload, [beKey]: next }
  }, {})
